"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdnanceSurveyIdentifiers$ = exports.OrdnanceSurveyIdentifiers$outboundSchema = exports.OrdnanceSurveyIdentifiers$inboundSchema = void 0;
exports.ordnanceSurveyIdentifiersToJSON = ordnanceSurveyIdentifiersToJSON;
exports.ordnanceSurveyIdentifiersFromJSON = ordnanceSurveyIdentifiersFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.OrdnanceSurveyIdentifiers$inboundSchema = z.object({
    os_address_toid: z.nullable(z.string()),
    os_roadlink_toid: z.nullable(z.string()),
    os_topo_toid: z.nullable(z.string()),
    parent_uprn: z.nullable(z.string()),
    uprn: z.nullable(z.string()),
    usrn: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "os_address_toid": "osAddressToid",
        "os_roadlink_toid": "osRoadlinkToid",
        "os_topo_toid": "osTopoToid",
        "parent_uprn": "parentUprn",
    });
});
/** @internal */
exports.OrdnanceSurveyIdentifiers$outboundSchema = z.object({
    osAddressToid: z.nullable(z.string()),
    osRoadlinkToid: z.nullable(z.string()),
    osTopoToid: z.nullable(z.string()),
    parentUprn: z.nullable(z.string()),
    uprn: z.nullable(z.string()),
    usrn: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        osAddressToid: "os_address_toid",
        osRoadlinkToid: "os_roadlink_toid",
        osTopoToid: "os_topo_toid",
        parentUprn: "parent_uprn",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OrdnanceSurveyIdentifiers$;
(function (OrdnanceSurveyIdentifiers$) {
    /** @deprecated use `OrdnanceSurveyIdentifiers$inboundSchema` instead. */
    OrdnanceSurveyIdentifiers$.inboundSchema = exports.OrdnanceSurveyIdentifiers$inboundSchema;
    /** @deprecated use `OrdnanceSurveyIdentifiers$outboundSchema` instead. */
    OrdnanceSurveyIdentifiers$.outboundSchema = exports.OrdnanceSurveyIdentifiers$outboundSchema;
})(OrdnanceSurveyIdentifiers$ || (exports.OrdnanceSurveyIdentifiers$ = OrdnanceSurveyIdentifiers$ = {}));
function ordnanceSurveyIdentifiersToJSON(ordnanceSurveyIdentifiers) {
    return JSON.stringify(exports.OrdnanceSurveyIdentifiers$outboundSchema.parse(ordnanceSurveyIdentifiers));
}
function ordnanceSurveyIdentifiersFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OrdnanceSurveyIdentifiers$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OrdnanceSurveyIdentifiers' from JSON`);
}
//# sourceMappingURL=ordnancesurveyidentifiers.js.map